import React, { useState, useEffect, useContext } from 'react';
import { DcContext } from './context'; 

const Reset = (props) => {
  // * state - none

  // * context 
  const appContext = useContext(DcContext);

  // * component mount/update
  useEffect(
    () => {
    },
    [props]
  ); 

  // * event handlers
  const onReset = (event) => {
    event.preventDefault();
    const formState = appContext.getFormState(); 
    // reset 
    formState.resetOffer();
    // store it in context 
    appContext.setFormState(formState); 
  };

  // * render 
  const isVisible = true; 
  return (
    <div className={"reset-link " + (isVisible ? "" : "display-none")}>
      <a className={"clear-link"} href='#' onClick={onReset}>clear all selections</a>
    </div>
  ); 

};

export default Reset;